<template>
  <modal
    transition="nice-modal-fade"
    width="680"
    :adaptive="true"
    :reset="true"
    height="auto"
    :name="modalName"
    class="listing--form-modal action--modal ank--history-modal"
    :scrollable="true"
    @before-open="beforeOpen"
  >
    <div class="modal--wrapper">
      <section-loading :show="loading" />
      <button type="button" class="close" @click="close">
        <img src="@/assets/img/icons/close-1.svg" />
      </button>
      <section class="modal--container">
        <div class="ank--history-title">Riwayat Review Oleh Admin</div>
        <div class="ank--history-subtitle">Semua riwayat status badge Agen Naik Kelas Anda.</div>
        <div class="ank--history-list">
          <div
            class="ank--history-item"
            v-for="(item, index) in history"
            :key="`ank-history-${index}`"
          >
            <div class="ank--history-content">
              <div class="ank--history-header">
                <div class="ank--history-status" :class="statusClass(item.type)">
                  {{ item.typeLabel }}
                </div>
                <div class="ank--history-date">
                  <v-icon small>mdi-clock-time-four-outline</v-icon>
                  <span>{{ formatDate(item.date) }}</span>
                </div>
              </div>
              <div class="ank--history-text" :class="`is-${item.type}`">{{ item.message }}</div>
            </div>
          </div>
          <div v-if="history.length === 0" class="ank--history-empty">
            Belum ada riwayat untuk ditampilkan.
          </div>
        </div>
      </section>
    </div>
  </modal>
</template>

<script>
const SectionLoading = () => import('@/components/content-loading/section-loading');

export default {
  name: 'agen-naik-kelas-history-modal',
  components: {
    SectionLoading,
  },
  data() {
    return {
      modalName: 'agen-naik-kelas-history-modal',
      history: [],
      loading: false,
    };
  },
  methods: {
    async beforeOpen() {
      this.loading = true;
      try {
        const history = await this.$store.dispatch('agenNaikKelas/getStatusHistory');
        this.history = Array.isArray(history) ? history : [];
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$modal.hide(this.modalName);
    },
    statusClass(type) {
      if (type === 'success') return 'is-success';
      if (type === 'danger') return 'is-danger';
      return 'is-pending';
    },
    formatDate(value) {
      if (!value) return '-';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '-';
      const day = `${date.getDate()}`.padStart(2, '0');
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';

.ank--history-title {
  font-family: Poppins-Bold;
  font-size: 24px;
  color: $color-text-black;
}

.ank--history-subtitle {
  margin-top: 6px;
  margin-bottom: 18px;
  color: $color-text-gray-2;
  font-size: $font-sm;
}

.ank--history-list {
  max-height: 60vh;
  overflow: auto;
  padding-right: 2px;
}

.ank--history-item {
  margin-bottom: 12px;
}

.ank--history-content {
  flex: 1;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 12px 14px;
  background-color: #fff;
}

.ank--history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ank--history-status {
  font-size: 14px;
  font-family: Poppins-Bold;
  color: #111;

  &.is-pending {
    color: #111;
  }

  &.is-success {
    color: #1e7a34;
  }

  &.is-danger {
    color: $color-beliruma-1;
  }
}

.ank--history-date {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #7a7a7a;
  font-family: Poppins-SemiBold;

  i {
    margin-right: 4px;
    color: #7a7a7a;
  }
}

.ank--history-text {
  font-size: 14px;
  color: #5f5f5f;
  line-height: 1.45;
  text-align: left;
  white-space: pre-line;

  &.is-success {
    color: $color-success;
  }

  &.is-danger {
    color: $color-beliruma-1;
  }
}

.ank--history-empty {
  border: 1px dashed #c8c8c8;
  border-radius: 10px;
  padding: 14px;
  font-size: 13px;
  color: #6d6d6d;
}
</style>
